<template lang="pug">
v-btn(
  v-if="valid",
  color="secondary",
  @click="handler",
  rounded,
  depressed,
  x-small
) Tax Exempt
</template>

<script>
import { EventBus } from "@/event-bus.js";

export default {
  props: ["order"],
  computed: {
    valid() {
      return (
        this.order &&
        this.order.status >= 0 &&
        this.proxy != "Test" &&
        this.order.payment.tax > 0
      );
    },
  },
  methods: {
    async handler() {
      EventBus.$emit("order-tax-exempt");
    },
  },
};
</script>

